import { mapSupportDescription } from "@/app/common-utils/question/map-support-description";

import {
  GroupedTravelDatesMagnoliaDataType,
  TravelDatePageContent,
} from "../types/travel-dates.type";

export function groupedTravelDatesMagnoliaData(
  magnoliaData: TravelDatePageContent
) {
  const magnoliaDataObj = magnoliaData.overlayArea[0];

  const userHeaderSection =
    magnoliaDataObj.stAssistantDescription?.[0]?.userHeaderSection;

  const userHeaderSectionAmt =
    magnoliaDataObj.amtAssistantDescription?.[0]?.userHeaderSection;

  const filteredAssistantBodySectionAmt = userHeaderSectionAmt
    ? Object.fromEntries(Object.entries(userHeaderSectionAmt).slice(1))
    : undefined;

  const filteredAssistantBodySection = userHeaderSection
    ? Object.fromEntries(Object.entries(userHeaderSection).slice(1))
    : undefined;

  const groupedData: GroupedTravelDatesMagnoliaDataType = {
    SINGLE_TRIP_DEFAULT: {
      headerText: magnoliaDataObj.stQuestionText,
      descriptionSection: {
        title:
          magnoliaDataObj?.stAssistantDescription?.[0].userHeaderSection[0]
            .text ?? "",
        body: mapSupportDescription(filteredAssistantBodySection) ?? "",
        isLoadMoreButton: magnoliaDataObj?.stLoadMoreButton ?? false,
        loadMoreButtonText: magnoliaDataObj?.stLoadMoreButtonText,
        drawerData: magnoliaDataObj?.stDefaultSupportDrawer,
      },
      errorMessage: {
        departureDateFutureErrorMessage:
          magnoliaDataObj?.departureDateErrorFutureDateST,
        departureDatePastErrorMessage:
          magnoliaDataObj?.departureDateErrorPastDateST,
        returnDateFutureErrorMessage:
          magnoliaDataObj?.returnDateErrorFutureDateST,
        returnDatePastErrorMessage: magnoliaDataObj?.returnDateErrorPastDateST,
        invalidDateErrorMessage: magnoliaDataObj?.departureReturnDateError,
      },
      modalContent: {
        sdtButtonText: magnoliaDataObj?.sdtButtonText,
        sdtHeaderText: magnoliaDataObj?.sdtHeaderText,
        sdtSubText: magnoliaDataObj?.sdtSubText,
        thcButtonText: magnoliaDataObj?.thcButtonText,
        thcHeaderText: magnoliaDataObj?.thcHeaderText,
        thcSubText: magnoliaDataObj?.thcSubText,
      },
    },
    ANNUAL_MULTI_TRIP_DEFAULT: {
      headerText: magnoliaDataObj.amtQuestionText,
      descriptionSection: {
        title:
          magnoliaDataObj?.amtAssistantDescription?.[0].userHeaderSection[0]
            .text ?? "",
        body: mapSupportDescription(filteredAssistantBodySectionAmt) ?? "",
        isLoadMoreButton: magnoliaDataObj?.amtLoadMoreButton ?? false,
        loadMoreButtonText: magnoliaDataObj?.amtLoadMoreButtonText,
        drawerData: magnoliaDataObj?.amtDefaultSupportDrawer,
      },
      errorMessage: {
        departureDateFutureErrorMessage:
          magnoliaDataObj?.departureDateErrorFutureDateAMT,
        departureDatePastErrorMessage:
          magnoliaDataObj?.departureDateErrorPastDateAMT,
        invalidDateErrorMessage: magnoliaDataObj?.departureReturnDateError,
      },
      modalContent: {
        sdtButtonText: magnoliaDataObj?.sdtButtonText,
        sdtHeaderText: magnoliaDataObj?.sdtHeaderText,
        sdtSubText: magnoliaDataObj?.sdtSubText,
        thcButtonText: magnoliaDataObj?.thcButtonText,
        thcHeaderText: magnoliaDataObj?.thcHeaderText,
        thcSubText: magnoliaDataObj?.thcSubText,
      },
    },
    SINGLE_TRIP_SELECTED: {
      headerText: magnoliaDataObj.stQuestionText,
      descriptionSection: {
        title: magnoliaDataObj?.dateSelectSTDescription?.[0].title ?? "",
        body:
          mapSupportDescription(
            magnoliaDataObj?.dateSelectSTDescription?.[0].questionBody
          ) ?? "",
        isLoadMoreButton: magnoliaDataObj?.stLoadMoreButton ?? false,
        loadMoreButtonText: magnoliaDataObj?.stLoadMoreButtonText,
        drawerData: magnoliaDataObj?.dateSelectSTSupportDrawer,
      },
      errorMessage: {
        departureDateFutureErrorMessage:
          magnoliaDataObj?.departureDateErrorFutureDateST,
        departureDatePastErrorMessage:
          magnoliaDataObj?.departureDateErrorPastDateST,
        returnDateFutureErrorMessage:
          magnoliaDataObj?.returnDateErrorFutureDateST,
        returnDatePastErrorMessage: magnoliaDataObj?.returnDateErrorPastDateST,
        invalidDateErrorMessage: magnoliaDataObj?.departureReturnDateError,
      },
      modalContent: {
        sdtButtonText: magnoliaDataObj?.sdtButtonText,
        sdtHeaderText: magnoliaDataObj?.sdtHeaderText,
        sdtSubText: magnoliaDataObj?.sdtSubText,
        thcButtonText: magnoliaDataObj?.thcButtonText,
        thcHeaderText: magnoliaDataObj?.thcHeaderText,
        thcSubText: magnoliaDataObj?.thcSubText,
      },
    },
    ANNUAL_MULTI_TRIP_SELECTED: {
      headerText: magnoliaDataObj.amtQuestionText,
      descriptionSection: {
        title: magnoliaDataObj?.dateSelectAMTDescription?.[0].title ?? "",
        body:
          mapSupportDescription(
            magnoliaDataObj?.dateSelectAMTDescription?.[0].questionBody
          ) ?? "",
        isLoadMoreButton: magnoliaDataObj?.amtLoadMoreButton ?? false,
        loadMoreButtonText: magnoliaDataObj?.amtLoadMoreButtonText,
        drawerData: magnoliaDataObj?.dateSelectAMTSupportDrawer,
      },
      errorMessage: {
        departureDateFutureErrorMessage:
          magnoliaDataObj?.departureDateErrorFutureDateAMT,
        departureDatePastErrorMessage:
          magnoliaDataObj?.departureDateErrorPastDateAMT,
        invalidDateErrorMessage: magnoliaDataObj?.departureReturnDateError,
      },
      modalContent: {
        sdtButtonText: magnoliaDataObj?.sdtButtonText,
        sdtHeaderText: magnoliaDataObj?.sdtHeaderText,
        sdtSubText: magnoliaDataObj?.sdtSubText,
        thcButtonText: magnoliaDataObj?.thcButtonText,
        thcHeaderText: magnoliaDataObj?.thcHeaderText,
        thcSubText: magnoliaDataObj?.thcSubText,
      },
    },
  } as const;

  return groupedData;
}
